let ctx = null;
let master = null;
let ambientNodes = [];
let chimeTimer = null;
let musicOn = false;

const PENTA = [523.25, 587.33, 659.25, 783.99, 880.0, 1046.5];

function ensureCtx() {
    if (!ctx) {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return null;
        ctx = new AC();
        master = ctx.createGain();
        master.gain.value = 0.5;
        master.connect(ctx.destination);
    }
    if (ctx.state === "suspended") ctx.resume();
    return ctx;
}

function startAmbient() {
    if (!ensureCtx()) return;
    stopAmbientNodes();
    const padGain = ctx.createGain();
    padGain.gain.setValueAtTime(0.0001, ctx.currentTime);
    padGain.gain.exponentialRampToValueAtTime(0.05, ctx.currentTime + 2.5);
    padGain.connect(master);
    [130.81, 196.0, 261.63].forEach((f, i) => {
        const osc = ctx.createOscillator();
        osc.type = i === 0 ? "sine" : "triangle";
        osc.frequency.value = f;
        osc.detune.value = i * 4 - 4;
        const lfo = ctx.createOscillator();
        lfo.frequency.value = 0.07 + i * 0.03;
        const lfoGain = ctx.createGain();
        lfoGain.gain.value = 0.012;
        lfo.connect(lfoGain).connect(padGain.gain);
        osc.connect(padGain);
        osc.start();
        lfo.start();
        ambientNodes.push(osc, lfo);
    });
    ambientNodes.push(padGain);
    let step = 0;
    chimeTimer = setInterval(() => {
        if (!musicOn) return;
        const f = PENTA[Math.floor(Math.random() * PENTA.length)];
        chime(f, 0.06);
        if (step % 4 === 3) setTimeout(() => musicOn && chime(f * 1.5, 0.035), 320);
        step++;
    }, 1600);
}

function stopAmbientNodes() {
    ambientNodes.forEach((n) => {
        try { n.stop ? n.stop() : n.disconnect(); } catch (e) { /* already stopped */ }
    });
    ambientNodes = [];
    if (chimeTimer) { clearInterval(chimeTimer); chimeTimer = null; }
}

function chime(freq = 783.99, vol = 0.12) {
    if (!ensureCtx()) return;
    const t = ctx.currentTime;
    const osc = ctx.createOscillator();
    osc.type = "sine";
    osc.frequency.value = freq;
    const g = ctx.createGain();
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(vol, t + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 1.6);
    osc.connect(g).connect(master);
    osc.start(t);
    osc.stop(t + 1.7);
}

function applause() {
    if (!ensureCtx()) return;
    const dur = 2.2;
    const buffer = ctx.createBuffer(1, ctx.sampleRate * dur, ctx.sampleRate);
    const data = buffer.getChannelData(0);
    for (let i = 0; i < data.length; i++) {
        data[i] = (Math.random() * 2 - 1) * (1 - i / data.length) * (Math.random() > 0.35 ? 1 : 0.25);
    }
    const src = ctx.createBufferSource();
    src.buffer = buffer;
    const filter = ctx.createBiquadFilter();
    filter.type = "bandpass";
    filter.frequency.value = 1400;
    filter.Q.value = 0.6;
    const g = ctx.createGain();
    g.gain.setValueAtTime(0.0001, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.22, ctx.currentTime + 0.25);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + dur);
    src.connect(filter).connect(g).connect(master);
    src.start();
}

function pop() {
    if (!ensureCtx()) return;
    const t = ctx.currentTime;
    const osc = ctx.createOscillator();
    osc.type = "sine";
    osc.frequency.setValueAtTime(420, t);
    osc.frequency.exponentialRampToValueAtTime(90, t + 0.18);
    const g = ctx.createGain();
    g.gain.setValueAtTime(0.18, t);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.2);
    osc.connect(g).connect(master);
    osc.start(t);
    osc.stop(t + 0.22);
}

function whoosh() {
    if (!ensureCtx()) return;
    const dur = 0.7;
    const buffer = ctx.createBuffer(1, ctx.sampleRate * dur, ctx.sampleRate);
    const data = buffer.getChannelData(0);
    for (let i = 0; i < data.length; i++) data[i] = Math.random() * 2 - 1;
    const src = ctx.createBufferSource();
    src.buffer = buffer;
    const filter = ctx.createBiquadFilter();
    filter.type = "bandpass";
    filter.Q.value = 1.4;
    filter.frequency.setValueAtTime(300, ctx.currentTime);
    filter.frequency.exponentialRampToValueAtTime(3200, ctx.currentTime + dur);
    const g = ctx.createGain();
    g.gain.setValueAtTime(0.0001, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.12, ctx.currentTime + 0.18);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + dur);
    src.connect(filter).connect(g).connect(master);
    src.start();
}

export const sound = {
    get isOn() { return musicOn; },
    toggle() {
        musicOn = !musicOn;
        if (musicOn) { ensureCtx(); startAmbient(); chime(783.99, 0.1); }
        else stopAmbientNodes();
        return musicOn;
    },
    chime(freq) { if (musicOn) chime(freq ?? PENTA[Math.floor(Math.random() * PENTA.length)], 0.1); },
    applause() { if (musicOn) applause(); },
    pop() { if (musicOn) pop(); },
    whoosh() { if (musicOn) whoosh(); },
};
